import React from 'react';
import i18n from '../../i18n';
import { Car } from 'lucide-react';
import Lightbox from 'react-awesome-lightbox';
import HeaderRowGrp from '../helpers/headerRowGrp';
import { AuctionCard } from './helpers/auctionCard';
import { CustomEnroll } from '../helpers/customEnroll';
import { getCategories } from '../../models/categories';
import { getGroupedAuctions } from '../../models/auctions';
import { AuctionListGrouped } from '../helpers/skeletons/AuctionListGrouped';
import { AuctionRowGrouped } from './helpers/auctionRowGrouped';
import { getOrganizations } from '../../models/organization';


//const user = getLoggedUser();
let is_logged = localStorage.getItem('is_logged_in') ? true : false;
let lng = localStorage.getItem('I18N_LANGUAGE');
let group_limit = localStorage.getItem('group_limit');
export class AuctionsListGrouped extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let groupID = path.substring(path.lastIndexOf('/') + 1, path.length);

    let urlParams = new URLSearchParams(window.location.search);
    let param1Value = urlParams.get('type');

    this.state = {
      section: 'main',
      catArrs: [],
      page_type: param1Value,
      categories: [],
      input: {
        auction: '',
      },
      organizations: [],
      auctions: {},
      limit: 30,
      meta: {},
      loading: false,
      group: groupID,
      gpData: {},
      orgData: {},
      enrolledUsers: 0,
      lightboxImages: [],
      is_active_light_box: false,
      now: () => {
        let time = new Date().toLocaleTimeString('en-US', {
          timeZone: 'Asia/Riyadh',
        });
        let dt = new Date().toISOString('en-US').split('T')[0];
        let newDt = dt + ' ' + time;
        newDt = new Date(newDt.replace(/-/g, '/'));
        return newDt;
      },
      isOpen: false,
      selectedCategories: [],
      selectedVehicleTypes: [],
      selectedMakes: [],
      selectedModels: [],
      searchTerm: '',
      vehicleTypeSearch: '',
      priceRange: { min: '', max: '' },
      yearRange: { min: '', max: '' },
      odometer: { min: '', max: '' },
      endDate: '',
      expandedSections: {
        category: true,
        vehicleType: true,
        make: false,
        model: false,
        endDate: false,
        odometer: false,
        priceRange: false,
        yearRange: false,
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.loadGroupedAuctions = this.loadGroupedAuctions.bind(this);
    this.getImagePopup = this.getImagePopup.bind(this);
    this.searchAuctions = this.searchAuctions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    let lt = group_limit || 30;
    this.loadGroupedAuctions(lt);
    this.loadAllCategories(params);
    this.loadAllOrganizations(params);
  }

  async loadAllOrganizations(params) {
    this.setState({ is_org_loading: true });
    if (typeof params.organization !== 'undefined') {
      var org = params.organization;
      this.setState({ orgArrs: [parseInt(org)] });
    }
    const response = await getOrganizations();
    if (response) {
      let organizations = response.data;
      this.setState({ organizations });
      this.setState({ is_org_loading: false });
    }
  }

  async loadAllCategories(params) {
    this.setState({ is_cat_loading: true });
    if (typeof params.category !== 'undefined') {
      var category = params.category;
      this.setState({ catArrs: [parseInt(category)] });
    }
    const response = await getCategories();
    if (response) {
      let categories = response.data;
      this.setState({ categories });
      this.setState({ is_cat_loading: false });
    }
  }

  createCategory(id, sub = false) {
    if (sub) {
      var subCatArrs = this.state.catArrs;
      if (subCatArrs.includes(id)) {
        const index = subCatArrs.indexOf(parseInt(id));
        if (index > -1) {
          subCatArrs.splice(index, 1);
        }
      } else {
        subCatArrs.push(parseInt(id));
      }
      this.setState({ subCatArrs: subCatArrs });
      this.applyFilters();
    } else {
      if (!id) {
        this.setState({ catArrs: [] });
        this.applyFilters();
        return;
      }
      var catArrs = this.state.catArrs;
      if (catArrs.includes(id)) {
        const index = catArrs.indexOf(parseInt(id));
        if (index > -1) {
          catArrs.splice(index, 1);
        }
      } else {
        catArrs.push(parseInt(id));
      }
      this.setState({ catArrs: catArrs });
      this.applyFilters();
    }
  }

  applyFilters() {
    //window.scrollTo(0, 0);
    var type = this.state.type;
    var section = this.state.section;
    //let { input } = this.state;
    var catArrs = this.state.catArrs;
    var cats = catArrs.join(',');
    if (catArrs.length < 1) {
      cats = '';
    }


    this.setState({
      category: cats,
      type: type,
      section: section,
      //organization: orgs,
    });

    this.loadGroupedAuctions({
      sec: section,
      type: type,
      category: cats,
      //organization: orgs,
    });
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadGroupedAuctions(params) {
    localStorage.setItem('group_limit', params.limit);
    this.setState({ limit: params.limit });
    let { group } = this.state;
    let q = '';
    if (group) {
      q += 'group=' + group;
    }
    if (!isNaN(params.limit)) {
      q += '&limit=' + params.limit;
    }
    if (typeof params.category !== 'undefined') {
      q += '&category=' + params.category;
    }

    this.setState({ loading: true });
    const response = await getGroupedAuctions(q);
    let auctions = response.data;
    let meta = response.meta;
    if (auctions) {
      this.setState({ auctions: auctions, meta, loading: false });
    }
    if (meta.group) {
      this.setState({ gpData: meta.group });
    }
    if (meta.organization) {
      this.setState({ orgData: meta.organization });
    }
    if (meta.enrolledUsers) {
      this.setState({ enrolledUsers: meta.enrolledUsers });
    }
  }

  async searchAuctions() {
    let { group } = this.state;
    let q = '';
    if (group) {
      q += 'group=' + group;
    }
    if (this.state.input.auction) {
      q += '&auction=' + this.state.input.auction;
    }
    q += '&lang=' + lng;

    this.setState({ loading: true });
    const response = await getGroupedAuctions(q);
    let auctions = response.data;
    let meta = response.meta;
    if (auctions) {
      this.setState({ auctions: auctions, meta, loading: false });
    }
    if (meta.group) {
      this.setState({ gpData: meta.group });
    }
    if (meta.organization) {
      this.setState({ orgData: meta.organization });
    }
    if (meta.enrolledUsers) {
      this.setState({ enrolledUsers: meta.enrolledUsers });
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, '/')) : null;
  }

  getImagePopup(active, images) {
    let lightboxImages = [];
    if (images) {
      images.forEach(function (arrayItem) {
        lightboxImages.push({
          url: arrayItem.image,
        });
      });
      this.setState({
        is_active_light_box: active,
        lightboxImages: lightboxImages,
      });
    }
  }

  sortByOrder(data) {
    let result = data;
    if (data.length) {
      result = data.sort((a, b) => a.order - b.order);
    }
    return result;
  }

  toggleFilter = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };


  render() {
    let { categories, auctions, catArrs, gpData, now } = this.state;
    let can_show_custom_enroll = false;
    let groupRegEndDate = new Date(this.createDate(gpData.reg_end_date));

    if (
      gpData.is_auctions_grouped &&
      !gpData.is_grouped_enroll &&
      is_logged &&
      groupRegEndDate > now()
    ) {
      can_show_custom_enroll = true;
    }
    auctions = this.sortByOrder(auctions);
    let total_auctions = this.state.meta.total;
    // let limit =
    //   isNaN(this.state.limit) || !this.state.limit
    //     ? false
    //     : Number(this.state.limit);
    // let user_role = user ? user.role : null;
    // let is_enrolled = this.props.is_enrolled;
    let endDate = this.state.gpData.reg_end_date;
    let endTime = new Date(this.createDate(endDate)).getTime();
    let visit_amount = Number(this.state.gpData.visit_amount);
    let current_lng = localStorage.getItem('I18N_LANGUAGE');
  
    let vehicle_only = false;
    if (
      auctions.length > 0 &&
      auctions[0].hasOwnProperty('is_vehicle') &&
      auctions[0].is_vehicle === 1
    ) {
      vehicle_only = true;
    }

    return (
      <React.Fragment>
        {this.state.loading && (
          <div className="container" id="auction-grouped">
            <AuctionListGrouped />
          </div>
        )}

        {!this.state.loading && (
          <>
            <div className="hero-banner" style={{ padding: '75px 0' }}>
              <div className="hero-content">
                <h1 className="hero-title" style={{ fontSize: '3rem' }}>
                  {current_lng === 'ar'
                    ? gpData.group_name_ar
                    : gpData.group_name}
                </h1>
                <HeaderRowGrp
                  reg_start_date={this.state.gpData.reg_start_date_formatted}
                  enrolledUsers={this.state.enrolledUsers}
                  endTime={endTime}
                />
              </div>
            </div>

            <div className="main-content">
              <div className="container" id="auction-grouped">
                <div className="row mob-padd-9">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="item2-gl">
                      <div className="button-sort-section m-auto">
                        <div className="dropdown search-section-dropdown">
                          <button
                            className="btn btn-secondary dropdown-toggle burger-menu"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={() => {
                              this.setState({
                                show_cat_dd: !this.state.show_cat_dd,
                              });
                            }}
                          >
                            <img
                              src={process.env.PUBLIC_URL + '/assets/images/burger menu.png'}
                              width="20"
                              alt=""
                            />
                          </button>

                          <ul
                            className={
                              this.state.show_cat_dd ? 'dropdown-menu d-block' : 'dropdown-menu'
                            }
                          >
                            {categories.map((item, i) => {
                              return (
                                <li>
                                  <a
                                    className="dropdown-item"
                                    href={true}
                                    onClick={() => {
                                      this.createCategory(item.id);
                                      this.setState({
                                        show_cat_dd: false,
                                      });
                                    }}
                                  >
                                    {current_lng === 'ar'
                                      ? item.category_name_ar
                                      : item.category_name}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                        {vehicle_only && (
                          <div className="buttons-section justify-content-start">
                            <button className="sort-button sbtn-1" onClick={this.toggleFilter}>
                              <img
                                src={process.env.PUBLIC_URL + '/assets/images/sort.png'}
                                width="20"
                                alt="sort"
                              />
                            </button>

                            <div className="category-buttons">
                              <button
                                type="button"
                                className={
                                  catArrs.includes(8)
                                    ? 'btn btn-primary sort-box-btn active'
                                    : 'btn btn-primary sort-box-btn'
                                }
                                onClick={() => {
                                  this.createCategory(8);
                                }}
                              >
                                <Car />
                                <span>{current_lng === 'ar' ? 'مركبات' : 'Vehicles'}</span>
                              </button>
                            </div>
                          </div>
                        )}
                        {!vehicle_only && (
                          <div>
                            <div className="buttons-section justify-content-start">
                              <button
                                className="sort-button sbtn-1"
                                onClick={this.toggleFilter}
                              >
                                <i className="fa fa-filter" width="20" style={{ color: "white" }}> </i>
                              </button>
                              All Filters  
                            </div>
                          </div>
                        )}
                   
                      </div>

                   
                      {can_show_custom_enroll && (
                        <div className="row">
                          <div className="col-xl-12 col-lg-12 col-md-12 w-desk-75 m-auto">
                            <div className="pagination mx-2 my-3">
                              <CustomEnroll group={gpData.id} />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="content overflow-hidden pt-1">
                        <div className="p-1 mb-9">
                          <h5 style={{ textAlign: 'start', padding: '5px' }}>
                            {i18n.t('showing')} {total_auctions} {i18n.t('auctions')}
                          </h5>

                          {auctions.length < 1 && (
                            <div className="alert alert-danger text-center">
                              {i18n.t('no_auctions_found')}
                            </div>
                          )}
                          {!this.state.grid &&
                            auctions.length > 0 &&
                            auctions.map((item, i) => {
                              let key = parseInt(i) + 1;
                              let _data = {
                                screen: 'groupList',
                                auction: item,
                                auctionId: item.id,
                                total_items: auctions.length,
                                company: 'Mzadcom',
                                price: item.start_amount,
                                title: item.title,
                                title_ar: item.title_ar,
                                description: 'Diesel Generators',
                                curr_amount: item.current_amount,
                                end_date: item.end_date_formatted,
                                start_date: item.start_date_formatted,
                                images: item.images,
                                total_views: item.total_views,
                                type: this.state.page_type,
                                can_bid: false,
                                status: item.status,
                                visit_amount: visit_amount,
                                group: this.state.gpData,
                              };
                              return (
                                <AuctionRowGrouped
                                  keys={key}
                                  getImagePopup={this.getImagePopup}
                                  {..._data}
                                />
                              );
                            })}
                          <div className="content overflow-hidden pt-1">
                            <div className="p-1 mb-9">
                              <div className="cards-section m-auto">
                                <div className="row">
                                  {this.state.grid &&
                                    auctions.length > 0 &&
                                    auctions.map((item, i) => {
                                      let key = parseInt(i) + 1;
                                      return (
                                        <AuctionCard
                                          keys={key}
                                          auction={item}
                                          images={item.images}
                                          getImagePopup={this.getImagePopup}
                                          screen="groupList"
                                          visit_amount={visit_amount}
                                          group={this.state.gpData}
                                          type={this.state.page_type}
                                          auctionId={item.id}
                                          total_items={auctions.length}
                                          company={'Mzadcom'}
                                          price={item.start_amount}
                                          title={item.title}
                                          title_ar={item.title_ar}
                                          curr_amount={item.current_amount}
                                          end_date={item.end_date_formatted}
                                          start_date={item.start_date_formatted}
                                          total_views={item.total_views}
                                          can_bid={true}
                                          status={item.status}
                                        />
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {this.state.is_active_light_box && (
          <Lightbox
            images={this.state.lightboxImages}
            onClose={() => {
              this.setState({ is_active_light_box: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}
